export default {
  namespace: 'tickets',
  en: {
    title: 'Tickets',
    common: {
      subject: 'Subject',
      status: 'Status',
      messages: 'Messages',
      lastActivity: 'Last activity',
      department: 'Department',
      handledBy: 'Handled by',
      reply: 'Reply',
      addTicket: 'Add ticket',
      answerTicket: 'Answer ticket',
      attachments: 'Attachments',
      closed: 'Closed',
      open: 'Open',
      copyLink: 'Copy link',
    },
    modals: {
      ticket: {
        create: {
          body: {
            label: 'Body',
            placeholder: 'How can we help you?',
          },
          department: {
            placeholder: 'Select a department',
          },
          attachments: {
            placeholder: 'Drag and drop some files here, or click to select files',
          },
        },
      },
    },
    components: {
      email: {
        attachments: 'Attachments',
        noContent: 'No content available, click here to load the HTML version of this e-mail.',
        from: 'From',
        to: 'To',
        cc: 'CC',
        bcc: 'BCC',
        knownName: 'Known to us as',
      },
    },
  },
  nl: {
    title: 'Tickets',
    common: {
      subject: 'Onderwerp',
      status: 'Status',
      messages: 'Berichten',
      lastActivity: 'Laatste activiteit',
      department: 'Afdeling',
      handledBy: 'Behandeld door',
      reply: 'Beantwoorden',
      addTicket: 'Ticket toevoegen',
      answerTicket: 'Ticket beantwoorden',
      attachments: 'Bijlagen',
      closed: 'Gesloten',
      open: 'Open',
      copyLink: 'Kopieer link',
    },
    modals: {
      ticket: {
        create: {
          body: {
            label: 'Bericht',
            placeholder: 'Hoe kunnen wij je helpen?',
          },
          department: {
            placeholder: 'Selecteer een afdeling',
          },
          attachments: {
            placeholder: 'Selecteer bijlagen of sleep ze hier naartoe',
          },
        },
      },
    },
    components: {
      email: {
        attachments: 'Bijlagen',
        noContent: 'Geen inhoud beschikbaar, klik hier om de HTML-versie van deze e-mail te laden.',
        from: 'Van',
        to: 'Aan',
        cc: 'CC',
        bcc: 'BCC',
        knownName: 'Bij ons bekend als',
      },
    },
  },
};
